import React, {useState} from 'react';
import {
  NumericTextBox
} from '@progress/kendo-react-inputs';
import styles from "./_selling-price-confirmation-dialog.module.scss";
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {toDollars} from "@amsanalytics/react-shared-library";
import {getDownPaymentRequestsWithLink} from "../../../../utils/downPaymentUtils";
import {useSelector} from "react-redux";
import {AppState} from "../../../../store/rootReducer";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {Label} from "@progress/kendo-react-labels";

interface SellingPriceConfirmationDialogProps {
  sellingPriceFromSelectedVehicle: number;
  onClose(): void;
  onSave: (newSellingPrice: number) => void;
}

export const SellingPriceConfirmationDialog: React.FC<SellingPriceConfirmationDialogProps> = (props) => {
  const currentApp = useSelector((state: AppState) => state.applications.editingApp!);
  const downPaymentsThatHaveAValidLink = getDownPaymentRequestsWithLink(currentApp.applicationDownPaymentRequests);
  const downPaymentAlreadyExists = downPaymentsThatHaveAValidLink.length > 0;
  const [newSellingPrice, setNewSellingPrice] = useState<number | null>(0);
  
  const sellingPriceIsInvalid = (newSellingPrice ?? 0) <= 0;

  return (
    <div className={styles.paymentForm}>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <div style={{ display: `flex`, alignItems: `center` }}>
          <ErrorOutlineIcon color="error" style={{ marginRight: `5px` }} />
          Enter a New Selling Price
        </div>
      </DialogTitle>
      <DialogContent>
        <Label>{`The selling price for the selected vehicle is invalid (${toDollars(props.sellingPriceFromSelectedVehicle)}). Enter a new valid price to be used on the quote.`}</Label>
        <div className={styles.fieldRow}>
          <NumericTextBox
            label={"New Selling Price"}
            style={{width: "100%"}}
            value={newSellingPrice}
            onChange={(e) => {
              const sanitizedPrice = Math.max(0, e.target.value ?? 0);
              setNewSellingPrice(sanitizedPrice);
            }}
            valid={!sellingPriceIsInvalid}
            format="c2"
            spinners={false}
            className={styles.input}
            disabled={downPaymentAlreadyExists}
            min={0}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <div className={styles.buttonRow}>
          <Button
            className={styles.button}
            onClick={() => props.onSave(newSellingPrice!)}
            disabled={sellingPriceIsInvalid}
          >
            Save
          </Button>
          <Button
            className={styles.button}
            onClick={() => props.onClose()}
          >
            Cancel
          </Button>
        </div>
      </DialogActions>
    </div>
  );
};
